import { z } from "zod";
import { toNumOrUndef } from "./toNumOrUndef";

const mkNum = (requiredMsg, minMsg) =>
  z.preprocess(toNumOrUndef, z.number(requiredMsg).min(0, { message: minMsg }));

function lossPair(reqCount, minCount, reqPaid, minPaid) {
  return z.object({
    count: mkNum(reqCount, minCount),
    paid: mkNum(reqPaid, minPaid),
  });
}

export const Step9Schema = z.object({
  /** losses[0..2] = last 12 months, prior 12 months, prior 12 months again */
  losses: z
    .array(
      z.object({
        autoLiability: lossPair(
          "Auto liability: Loss count (Open or closed) is required",
          "Auto liability: Loss count (Open or closed) need to be at least 0",
          "Auto liability: Losses paid (Open or reserved) is required",
          "Auto liability: Losses paid (Open or reserved) need to be at least 0"
        ),
        physicalDamage: lossPair(
          "Physical damage: Loss count (Open or closed) is required",
          "Physical damage: Loss count (Open or closed) need to be at least 0",
          "Physical damage: Losses paid (Open or reserved) is required",
          "Physical damage: Losses paid (Open or reserved) need to be at least 0"
        ),
        cargo: lossPair(
          "Cargo: Loss count (Open or closed) is required",
          "Cargo: Loss count (Open or closed) need to be at least 0",
          "Cargo: Losses paid (Open or reserved) is required",
          "Cargo: Losses paid (Open or reserved) need to be at least 0"
        ),
        tgl: lossPair(
          "Truckers general liability: Loss count (Open or closed) is required",
          "Truckers general liability: Loss count (Open or closed) need to be at least 0",
          "Truckers general liability: Losses paid (Open or reserved) is required",
          "Truckers general liability: Losses paid (Open or reserved) need to be at least 0"
        ),
      })
    )
    .length(3, "Three loss periods are required"),
});
